// Constant
import { FAKE_RESPONSE } from 'constant/shared.constant'

// Interfaces
import { IAboutUsFounderApiGetResponse } from 'interfaces/back-office/content-management/about-us/founder/about-us-founder-api.interface'
// Moment
import moment from 'moment'

export const ABOUT_US_FOUNDER: IAboutUsFounderApiGetResponse = {
  ...FAKE_RESPONSE,
  res: {
    message: 'Get About Us Founder Success',
    success: '1',
    data: {
      id: 1,
      content: 'Content',
      image: 'Image',
      status: true,
      createdAt: moment().toString(),
      updatedAt: moment().toString(),
    },
  },
}
